import React from 'react';

function SectionHead({ title, copy }) {
  return (
    <div className="section-head">
      {/* <h2>{title}</h2> */}
      <p>{copy}</p>
    </div>
  );
}

export default SectionHead;
